import { createReducer, on } from '@ngrx/store';
import { DialogData, ProjektDaten } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import { addZeitFailed, addZeitStart, addZeitSucceeded } from '../actions/Zeit-add.actions';
import { loadZeitStart, loadZeitSucceeded } from '../actions/Zeit-output.actions';
import { editZeitFailed, editZeitStart, editZeitSucceeded} from '../actions/Zeit-edit.actions';
import { deleteZeitFailed, deleteZeitStart, deleteZeitSucceeded } from '../actions/Zeit-del.actions';
import { loadProjektFailed, loadProjektStart, loadProjektSucceeded } from '../actions/project-output.actions';
import { loadPartProjektFailed, loadPartProjektStart, loadPartProjektSucceeded } from '../actions/project-part-output.actions';
import { loadSeekFailed, loadSeekStart, loadSeekSucceeded } from '../actions/Zeit-seek.actions';
import {
  loadProjektSelectboxFailed,
  loadProjektSelectboxStart,
  loadProjektSelectboxSucceeded
} from '../actions/project-selectbox.actions';
import {ProjektItem} from '../../../projektverwaltung/projekt.model';
import {NodeItem} from '../../../projektverwaltung/node.model';
import {
  getFilteredSeekDateFailed,
  getFilteredSeekDateStart,
  getFilteredSeekDateSucceeded
} from '../actions/filter-seek-date.actions';
import {getDateAndSeekFailed, getDateAndSeekStart, getDateAndSeekSucceeded} from '../actions/date-and-seek.actions';
import {getFilterSeekFailed, getFilterSeekStart, getFilterSeekSucceeded} from '../actions/filter-seek.actions';
import {SpesenItem} from '../../spesen.model';
import {loadSpesenFailed, loadSpesenStart, loadSpesenSucceeded} from '../actions/getAllSpesen.actions';
import {deleteSpeseFailed, deleteSpeseStart, deleteSpeseSucceeded} from '../actions/spese-del.actions';
import {loadSpesenartenFailed, loadSpesenartenStart, loadSpesenartenSucceeded} from '../actions/spesenart.actions';
import {SpesenartItem} from '../../spesenart.model';
import {addSpesenFailed, addSpesenStart, addSpesenSucceeded} from '../actions/spesen-add.actions';
import {editSpesenFailed, editSpesenStart, editSpesenSucceeded} from '../actions/spesen-edit.actions';
import {
  deleteAllSpesenOfZeitFailed,
  deleteAllSpesenOfZeitStart,
  deleteAllSpesenOfZeitSucceeded
} from '../actions/allSpesenOfZeit-del.actions';
import {setTimeToZeroFailed, setTimeToZeroStart, setTimeToZeroSucceeded} from '../actions/setTimeToZero-edit.actions';
import {CacheItem} from '../../cache.model';
import {addCacheFailed, addCacheStart, addCacheSucceeded} from '../actions/cache-add.actions';
import {loadCacheFailed, loadCacheStart, loadCacheSucceeded} from '../actions/getCacheNodes.actions';
import {DashboardItem} from "../../../landingpage/dashboard.model";
import {addSpesenartFailed, addSpesenartStart, addSpesenartSucceeded} from '../actions/spesenart-add.actions';
import {deleteSpesenartFailed, deleteSpesenartStart, deleteSpesenartSucceeded} from '../actions/spesenart-del.actions';
import {editSpesenartFailed, editSpesenartStart, editSpesenartSucceeded} from '../actions/spesenart-edit.actions';
import {loadIstZeitFailed, loadIstZeitStart, loadIstZeitSucceeded} from '../actions/getIstZeit';
import {
  loadInactiveSpesenartenFailed,
  loadInactiveSpesenartenStart,
  loadInactiveSpesenartenSucceeded
} from '../actions/getInactiveSpesenart.action';
import {activateSpesenartFailed, activateSpesenartStart, activateSpesenartSucceeded} from '../actions/spesenart-activate.actions';
import {alleVerrechnetFailed, alleVerrechnetStart, alleVerrechnetSucceeded} from '../actions/alleVerrechnet.actions';
import {
  loadTaetCacheFailed,
  loadTaetCacheStart,
  loadTaetCacheSucceeded
} from '@src/app/pages/Zeiterfassung/store/actions/getTaetCache.actions';
import {addRolleFailed, addRolleStart, addRolleSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/rolle-add.actions';
import {State} from '@src/app/pages/Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {
  loadSaldoReportFailed,
  loadSaldoReportStart,
  loadSaldoReportSucceeded
} from '@src/app/pages/Zeiterfassung/store/actions/getSaldoReport.actions';
import {
  getFerienReportFailed,
  getFerienReportStarted,
  getFerienReportSucceeded
} from '@src/app/pages/Zeiterfassung/store/actions/getFerienReport';

export interface Zeitstate {
  isLoading: boolean;
  isAddingZeiterfassung: boolean;
  item: DialogData[];
  projektDaten: ProjektDaten[];
  partProjektDaten: ProjektDaten[];
  nodes: {
    items: NodeItem[];
  };
  spesenarten: SpesenartItem[];
  selectboxProjekte: NodeItem[];
  spesen: SpesenItem[];
  cacheNodes: DashboardItem[];
  taetNodes: string[];
  istZeit: number;
  sollZeit: number;
}

export const initialState: Zeitstate = {
  isLoading: false,
  isAddingZeiterfassung: false,
  item: [],
  projektDaten: [],
  partProjektDaten: [],
  nodes: {
    items: [],
  },
  selectboxProjekte: [],
  spesen: [],
  spesenarten: [],
  cacheNodes: [],
  taetNodes: [],
  istZeit: 0,
  sollZeit: 0,
};


const ons = [
  on(loadSpesenStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadSpesenSucceeded, (state: Zeitstate, action) => ({
    ...state,
    isLoading: false,
    spesen: action.item,
  })),
  on(loadSpesenFailed, (state: Zeitstate) => ({ ...state, isLoading: false })),

  on(loadIstZeitStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadIstZeitSucceeded, (state: Zeitstate, action) => ({
    ...state,
    isLoading: false,
    istZeit: action.zeit['istZeit'],
    sollZeit: action.zeit['sollZeit'],
  })),
  on(loadIstZeitFailed, (state: Zeitstate) => ({ ...state, isLoading: false })),

  on(loadProjektSelectboxStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadProjektSelectboxSucceeded, (state: Zeitstate, action) => ({
    ...state,
    isLoading: false,
    selectboxProjekte: action.projektDaten,
  })),
  on(loadProjektSelectboxFailed, (state: Zeitstate) => ({ ...state, isLoading: false })),

  on(loadZeitStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadZeitSucceeded, (state: Zeitstate, action) => ({
    ...state,
    isLoading: false,
    item: action.item,
  })),


  /* post / inset into */
  on(addZeitStart, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addZeitFailed, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addZeitSucceeded, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  /* post / inset into */
  on(addSpesenStart, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addSpesenSucceeded, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addSpesenFailed, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),

  on(addSpesenartStart , (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addSpesenartSucceeded, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addSpesenartFailed, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),

  on(getFerienReportStarted , (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(getFerienReportSucceeded, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(getFerienReportFailed , (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),

  on(addCacheStart, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addCacheSucceeded, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  on(addCacheFailed, (state: Zeitstate) => ({...state, isAddingZeiterfassung: true })),
  /* put / update */
  on(editZeitStart, (state: Zeitstate) => ({...state, isEditingZeiterfassung: true})),
  on(editZeitFailed, (state: Zeitstate) => ({...state, isEditingZeiterfassung: false})),
  on(editZeitSucceeded , (state: Zeitstate, action) => ({
    ...state,
    item: state.item.map((item) => {
      if (item.id === action.item.id) { return action.item; }
      return item;
    }),
    isEditingZeiterfassung: false
  })),
  /* delete */
  on(editSpesenStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(editSpesenFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(editSpesenSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  /* delete */
  on(editSpesenartStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(editSpesenartFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(editSpesenartSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  /* delete */
  on(setTimeToZeroStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(setTimeToZeroFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(setTimeToZeroSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  /* delete */
  on(deleteZeitStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(deleteZeitFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(deleteZeitSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  /* delete */
  on(deleteSpeseStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(deleteSpeseFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(deleteSpeseSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  on(deleteSpesenartStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(deleteSpesenartFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(deleteSpesenartSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  on(activateSpesenartStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(activateSpesenartFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(activateSpesenartSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  /* delete */
  on(deleteAllSpesenOfZeitStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(deleteAllSpesenOfZeitSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(deleteAllSpesenOfZeitFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  on(alleVerrechnetStart, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: true })),
  on(alleVerrechnetSucceeded, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),
  on(alleVerrechnetFailed, (state: Zeitstate) => ({ ...state, isDeletingZeiterfassung: false })),

  /* Projekt in Zeitverwaltung */
  on(loadProjektStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadProjektFailed , (state: Zeitstate) => ({ ...state, isLoading: false })),
  on(loadProjektSucceeded, (state: Zeitstate, action) => ({
    ...state,
    projektDaten: action.projektDaten,
    isLoading: false,
  })),
  on(loadSpesenartenStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadSpesenartenFailed , (state: Zeitstate) => ({ ...state, isLoading: false })),
  on(loadSpesenartenSucceeded, (state: Zeitstate, action) => ({
    ...state,
    spesenarten: action.item,
    isLoading: false,
  })),
  on(loadInactiveSpesenartenStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadInactiveSpesenartenFailed , (state: Zeitstate) => ({ ...state, isLoading: false })),
  on(loadInactiveSpesenartenSucceeded, (state: Zeitstate, action) => ({
    ...state,
    spesenarten: action.item,
    isLoading: false,
  })),
  on(loadCacheStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadCacheFailed , (state: Zeitstate) => ({ ...state, isLoading: false })),
  on(loadCacheSucceeded, (state: Zeitstate, action) => ({
    ...state,
    cacheNodes: action.item,
    isLoading: false,
  })),

  on(loadTaetCacheStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadTaetCacheFailed , (state: Zeitstate) => ({ ...state, isLoading: false })),
  on(loadTaetCacheSucceeded, (state: Zeitstate, action) => ({
    ...state,
    taetNodes: action.item,
    isLoading: false,
  })),

  /* laedt Teildaten fuer die Boxen */
  on(loadPartProjektStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadPartProjektSucceeded, (state: Zeitstate, action) => ({
    ...state,
    partProjektDaten: action.partProjektDaten,
  })),
  on(loadPartProjektFailed,  (state: Zeitstate) => ({ ...state, isShowingZeiterfassung: false })),

  /* Suche Inputfeld in der Zeiterfassung */
  on(loadSeekStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadSeekSucceeded, (state: Zeitstate, action) => ({
    ...state,
    item: action.item,
  })),
  on(loadSeekFailed,  (state: Zeitstate, action) => ({
    ...state,
    isShowingSeekZeiterfassung: false })),

  /* Suche nach Datum mit Datumsfeld */
  on(getFilterSeekStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(getFilterSeekSucceeded, (state: Zeitstate, action) => ({
    ...state,
    item: action.item, /* Item ist der Ort in dem die Werte gespeichert sind die ich brauche bzw die ich angezeigt haben will */
  })),
  on(getFilterSeekFailed,  (state: Zeitstate, action) => ({ ...state, isShowingSeekZeiterfassung: false })),

  /* Suche und Datum zusammen */
  on(getDateAndSeekStart,  (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(getDateAndSeekSucceeded, (state: Zeitstate, action) => ({
    ...state,
    item: action.item,
  })),
  on(getDateAndSeekFailed ,  (state: Zeitstate, action) => ({ ...state, isShowingSeekZeiterfassung: false })),

  /* Datum und Suche beides / einzeln nach Joel */
  on(getFilteredSeekDateStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(getFilteredSeekDateSucceeded, (state: Zeitstate, action) => ({
    ...state,
    item: action.item,
  })),
  on(getFilteredSeekDateFailed, (state: Zeitstate) => {
    return ({...state, isLoading: false});
  }),
  on(loadSaldoReportStart, (state: Zeitstate) => ({ ...state, isLoading: true })),
  on(loadSaldoReportSucceeded, (state: Zeitstate) => ({ ...state, isLoading: false })),
  on(loadSaldoReportFailed, (state: Zeitstate) => ({ ...state, isLoading: false })),
];

export const zeiterfassungReducer = createReducer(initialState, ...ons);
